import FeedbackFormFailure from './FeedbackFormFailure';
import FeedbackFormInput from './FeedbackFormInput';
import FeedbackFormSuccess from './FeedbackFormSuccess';
export default {
  Failure: FeedbackFormFailure,
  Input: FeedbackFormInput,
  Success: FeedbackFormSuccess
};